import { render, staticRenderFns } from "./button-print-ticket.vue?vue&type=template&id=19225cb2"
import script from "./button-print-ticket.vue?vue&type=script&setup=true&lang=ts"
export * from "./button-print-ticket.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports